import Auth from "../../../../Auth.js";
import { createEntityImageApi, type GenerateCandidateResponse } from "../../../EntityImage/lib/entityImageApi";
import type { ReferenceImagePayload, StylePresetOption } from "../../../EntityImage/lib/types";

export const worldbuildingImageApi = createEntityImageApi("/api/worldbuildingEntries");

export interface WorldbuildingStylePresetsResponse {
  success: true;
  stylePresets: (StylePresetOption & { defaultAspectRatio: string })[];
  /** Derived from the entry's type, e.g. Item → item-study. */
  defaultStylePresetId: string;
  /** Derived from the entry's type, e.g. Setting → 3:2. */
  defaultAspectRatio: string;
}

export interface WorldbuildingSummarizeResponse {
  success: true;
  subject: string;
  mood: string | null;
}

export function listWorldbuildingImageStylePresets(entryId: string): Promise<WorldbuildingStylePresetsResponse> {
  return worldbuildingImageApi.listStylePresets<WorldbuildingStylePresetsResponse>(entryId);
}

export function summarizeWorldbuildingVisuals(entryId: string, userDescription: string): Promise<WorldbuildingSummarizeResponse> {
  return Auth.fetchWithIdToken(worldbuildingImageApi.imagesUrl(entryId, "/summarize"), { userDescription });
}

export function generateWorldbuildingImage(
  entryId: string,
  params: {
    subject: string;
    mood: string | null;
    stylePresetId: string;
    aspectRatio?: string;
    referenceImage?: ReferenceImagePayload | null;
    referenceImageGuidance?: string;
    userDescription?: string;
    // Shared across a batch's tile requests so the ledger groups their charges into one line —
    // see mergeEntityImageBatchEntries.
    batchId?: string;
  },
): Promise<GenerateCandidateResponse> {
  return Auth.fetchWithIdToken(worldbuildingImageApi.imagesUrl(entryId, "/generate"), {
    subject: params.subject,
    mood: params.mood,
    stylePresetId: params.stylePresetId,
    aspectRatio: params.aspectRatio,
    referenceImage: params.referenceImage ?? undefined,
    referenceImageGuidance: params.referenceImageGuidance || undefined,
    userDescription: params.userDescription || undefined,
    batchId: params.batchId ?? undefined,
  });
}
